export const InputStyles = {
  baseStyle: {
    input: {
      background: "blue",
    },
  },
  variants: {
    base: {
      field: {
        borderRadius: "base",
        border: "base",
        borderColor: "input_border_color_primary",
        _focus: {
          borderColor: "input_border_focus_color_primary",
        },
      },
    },

    error: {
      field: {
        borderRadius: "base",
        border: "base",
        borderColor: "error",
        _focus: {
          borderColor: "error",
        },
      },
    },

    dashed: {
      field: {
        border: "2px dashed",
        borderColor: "input_border_color_primary",
      },
    },

    unbordered: {
      field: {
        border: "none",
      },
    },
  },
  sizes: {
    sm: {
      fields: {
        fontSize: "base",
      },
    },
  },
  defaultProps: {
    variant: "base",
  },
}
